import * as types from "../../common/state/actionTypes";

export function logError(error) {
  return { type: types.LOG_ERROR, error };
}
